module.exports = __webpack_public_path__ + "img/phone.eebb6ecd.jpg";